// extracted by mini-css-extract-plugin
export default {"zhibo":"index_zhibo_7OjX-"};